<template>
    <div>
        <div class="d-flex flex-row justify-content-center gap-3">
            <h2 class="text-center mb-8">{{ getTitle }}</h2>
            <i data-toggle="tooltip" data-placement="bottom" data-html="true"
               :title="getInfo"
               class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                <thead class="thead-light">
                <tr class="text-left">
                    <th :class="[brand ? 'w-25' : '']">{{ getTableColName }}</th>
                    <th v-if="product">{{ __('general.brand') }}</th>
                    <th :class="[brand ? 'w-25' : '']">{{ __('statistics.popularity_rank') }}</th>
                    <th :class="[brand ? 'w-25' : '']">{{ __('statistics.previous_rank') }}</th>
                    <th :class="[brand ? 'w-25' : '']">{{ __('statistics.relative_demand') }}</th>
                    <th v-if="product">{{ __('statistics.inventory_status') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="statistic in statistics" class="text-left">
                    <td>
                        <span class="text-gray-800 font-weight-bold text-hover-primary mt-2">
                            <span v-if="product">{{ shortName(statistic.title) }}</span>
                            <span v-if="brand">{{ shortName(statistic.name) }}</span>
                        </span>
                    </td>
                    <td v-if="product">
                        <span class="text-monospace d-block mt-2">
                            {{ getBrandName(statistic.brand) }}
                        </span>
                    </td>
                    <td>
                        <span class="text-monospace d-block mt-2">
                            {{ statistic.rank }}
                        </span>
                    </td>
                    <td>
                        <span class="text-monospace d-block mt-2">
                            {{ statistic.previous_rank }}
                        </span>
                    </td>
                    <td>
                        <span class="text-monospace d-block mt-2">
                            {{ getRelativeDemand(statistic.relative_demand) }}
                        </span>
                    </td>
                    <td v-if="product">
                        <span class="text-monospace d-block mt-2">
                            {{ getInventory(statistic.inventory_status) }}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        statistics: {
            types: [Object, Array],
        },
        product: Boolean,
        brand: Boolean,
    },

    computed: {
        getTitle() {
            return this.product ? this.__('statistics.best_seller_products_in_category', {'category' : this.statistics[0].category_l1})
                : this.__('statistics.best_seller_brands_in_category', {'category' : this.statistics[0].category_l1})
        },
        getTableColName() {
            return this.product ? this.__('general.product_name') : this.__('general.brand_name')
        },
        getInfo() {
            return this.product ? this.__('statistics.info_best_seller_products')
                : this.__('statistics.info_best_seller_brands')
        },
    },

    methods: {
        shortName(name) {
            if (name.length < 42) {
                return name
            }

            return name.substring(0, 42) + '...'
        },
        getRelativeDemand(demandType) {
            let type
            switch (demandType) {
                case 'VERY_LOW':
                    type = this.__('statistics.very_low')
                    break
                case 'LOW':
                    type = this.__('statistics.low')
                    break
                case 'MEDIUM':
                    type = this.__('statistics.medium')
                    break
                case 'HIGH':
                    type = this.__('statistics.high')
                    break
                case 'VERY_HIGH':
                    type = this.__('statistics.very_high')
                    break
                default:
                    type = this.__('statistics.relative_demand_unspecified')
                    break
            }
            return type
        },
        getInventory(inventoryType) {
            let type
            switch (inventoryType) {
                case 'IN_STOCK':
                    type = this.__('statistics.in_stock')
                    break
                case 'OUT_OF_STOCK':
                    type = this.__('statistics.out_of_stock')
                    break
                case 'NOT_IN_INVENTORY':
                    type = this.__('statistics.not_in_inventory')
                    break
                default:
                    type = this.__('statistics.inventory_status_unspecified')
                    break
            }
            return type
        },
        getBrandName(brand) {
            return brand ? brand : this.__('general.unknown')
        },
    },
}
</script>
<style>
u {
    border-bottom: 1px dotted #000;
    text-decoration: none;
}
</style>
